<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Preface</a></div>
<div class="SOM_part"><a href="#/p1">Part 1—Why Can't We Be Happy?</a></div>
<div class="SOM_chap"><a href="#/p1chap1"><span class="mev1">1</span> Why Can't I Be Happy?</a></div>
<div class="SOM_chap"><a href="#/p1chap2"><span class="mev1">2</span> Hope for a Culture of Bored and Empty Selves</a></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">PART 2—IS THERE A REAL SOLUTION TO OUR DILEMMA?</span></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample"><span class="mev1">3</span> The Question of God, Part 1</span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample"><span class="mev1">4</span> The Question of God, Part 2</span></div>
<div class="SOM_chap"><span href="#/p2chap3" title="Link target outside of Sample"><span class="mev1">5</span> The Luminous Nazarene</span></div>
<div class="SOM_chap"><span href="#/p2chap4" title="Link target outside of Sample"><span class="mev1">6</span> My Own Journey as Jesus' Apprentice</span></div>
<div class="SOM_part"><span href="#/p3" title="Link target outside of Sample">PART 3—HOW CAN THE SOLUTION HELP ME CHANGE?</span></div>
<div class="SOM_chap"><span href="#/p3chap1" title="Link target outside of Sample"><span class="mev1">7</span> Rethinking the Whole Thing</span></div>
<div class="SOM_chap"><span href="#/p3chap2" title="Link target outside of Sample"><span class="mev1">8</span> Two Essentials for Getting Good at Life</span></div>
<div class="SOM_chap2"><span href="#/p3chap3" title="Link target outside of Sample"><span class="mev1">9</span> Avoiding the Three Jaws of Defeat</span></div>
<div class="border">
<div class="SOM_chap1"><span href="#/p3chap4" title="Link target outside of Sample"><span class="mev1">10</span> How to Unclog Your Spiritual Arteries and Develop the Heart to Work with God</span></div>
<div class="SOM_part"><span href="#/p4" title="Link target outside of Sample">PART 4—IS THIS LIFE ALL THERE IS?</span></div>
<div class="SOM_chap"><span href="#/p4chap1" title="Link target outside of Sample"><span class="mev1">11</span> From Here to Eternity</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Epilogue</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Praise for <i>The God Question</i></span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?7d15b0bf